// extracted by mini-css-extract-plugin
export default {"errorContainer":"InputError_errorContainer__XquEs","errorText":"InputError_errorText__ycRuh"};